module.exports = __webpack_public_path__ + "static/img/scene-cpjs.ca06445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-cpjs.png
// module id = IHtk
// module chunks = 1